/**
 * src/domains/applications/useApplicationStore.ts
 *
 * React hook for job applications.
 */
import { useSyncExternalStore } from 'react';

import { applicationStore, loadMyApplications } from './applications.store';

export function useApplicationStore() {
  const state = useSyncExternalStore(
    applicationStore.subscribe,
    applicationStore.getSnapshot,
  );

  return {
    ...state,
    loadMyApplications,
  };
}
